import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

const PencilIcon = (props) => (
  <Svg
    width={20}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="m17.384 3.875-1.516-1.517a1.3 1.3 0 0 0-.925-.383 1.3 1.3 0 0 0-.925.383l-1.784 1.784 3.367 3.366 1.783-1.783a1.303 1.303 0 0 0 0-1.842v-.008ZM3.085 16.558c-.083.3.2.575.492.484l3.9-1.284-3.225-3.25-1.159 4.059-.008-.009ZM11.742 4.742 4.75 11.908l3.258 3.342L15 8.083l-3.258-3.341Z"
      fill="#8FC7FF"
    />
  </Svg>
)

export default PencilIcon
